/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'

interface PropsType {
	index: number
	value: number
	children: React.ReactNode
}

export const TabPanelView = (props: PropsType) => {
	return (
		<View
			css={style}
			hidden={props.value !== props.index}
			id={`scrollable-force-tabpanel-${props.index}`}
			aria-labelledby={`scrollable-force-tab-${props.index}`}
		>
			{props.value === props.index && <>{props.children}</>}
		</View>
	)
}

const style = css({
	width: '100%',
	height: '100%',
})
